import axios from "axios";

export const apiRexxbot = axios.create({
	baseURL: process.env.REACT_APP_API_REXXBOT_URL || "https://api.rexxbot.com/v1",
});
